export enum Enumcontainer {}

export enum PageDetails {
  PageSize = 100,
  TotalRecords = 100,
  //PageSizeOptions = [10, 20, 50, 100],
}

export enum UserTypes {
  SuperUser = 1,
  LabUser = 2,
  ClientUser = 3,
}

export enum SampleStatusTypes {
  AnalysisPending = 1,
  AnalysisInprogress = 2,
  ResultsAdded = 3,
  ResultsApproved = 4,
  ResultsPublished = 5,
  MigrationSamples = 6,
  ReportDeactivated = 7,
}

export enum ReportTemplateTypesEnum {
  Default = 1,
  Default2 = 2,
  Navi = 11,
}

export enum SuccessMessagesEnum {
  AddedSuccessfully = -1,
  UpdatedSuccessfully = -2,
}

export enum SampleTypesEnum {
  General = 1,
  ferroGraphy = 2,
  GeneralAndFerrography = 3,
  TataBaseOil = 4,
  TransformerOil = 5,
}

export enum CharRatingTypes {
  Normal = 1,
  WarningLower = 2,
  WarningUpper = 3,
  CriticalLower = 4,
  CriticalUpper = 5,
}
export enum TransformerOilRating {
  Good = 8,
  Fair = 9,
  Poor = 10,
}
export enum AnalysisSectionEnum {
  oil_condition = 1,
  OIL_CONDITION_CONTAMINATION = 2,
  WEAR_METALS = 3,
  ADDITIVES = 4,
}

export enum MediaFileCategoryTypesEnum {
  NABL_Logo = 1,
  Technical_Manager = 2,
  Authorized_Signature = 3,
}

export enum LeadStatusTypesEnum {
  Lead_Created = 1,
  Samples_Registered = 2,
  Not_Required = 3,
}

export enum TestRatingTypesEnum {
 Critical = 1,
 Marginal = 2,
 Normal = 3,
}